// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"118":"666c8960","430":"3ff7a490","686":"dcfc3ab8","694":"ed540d2e","817":"ed540d2e","926":"ed540d2e"}[chunkId] + ".chunk.css";
};